<template>
  <div class="flex flex-col relative">
    <label class="fs-13 block mb-1 font-bold" :for="props.id">{{ props.label }}</label>
    <input
      :id="props.id"
      v-model="valueModel"
      :name="props.name"
      :placeholder="props.placeholder"
      :disabled="props.disabled"
      class="
      fs-16-ls block w-full
      p-3 mb-4
       bg-input-text-bg text-input-text-text
      border border-input-text-stroke rounded-s
      focus-visible:outline-input-text-focused-stroke"
      :class="{
        'bg-transparent': props.disabled,
        'border-input-text-error-stroke': props.hasError || props.errorText
      }"
      type="text"
      @input="validateInput($event)"
    />
    <span v-if="props.hasError || props.errorText" class="text-red-500 fs-13 in-car:fs-19 mt-1 absolute -bottom-2 left-0">
      {{ props.errorText || t('errors.required_error') }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
const props = defineProps({
  id: {
    type: String,
    default: () => '',
  },
  name: {
    type: String,
    default: () => '',
  },
  label: {
    type: [String, Number],
    default: () => '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  hasError: {
    type: Boolean,
    default: false,
  },
  errorText: {
    type: String,
    default: '',
  }
});

const valueModel = defineModel('valueModel');
const errorOnlyNumbers = ref();

const validateInput = (event: InputEvent | Event) => {
  valueModel.value = String(valueModel.value).replace(/\D/g, '');
};
</script>